import { useCallback } from "react";
import { highlight } from "../../helpers/StringHelper";
import { useResourcesList } from "../ResourcesList/resourcesList";
import { matchSearchTerms } from "../Utils/htmlStringUtils";
import { filterMatchingNodes } from "../Utils/filterMatchingNodes";

const SitemapItem = ({ node }) => {
  const { title, resourcePath } = node;

  const resourcesList = useResourcesList();
  const { search } = resourcesList;
  const searchTerms = search?.terms;

  const matchesSearchTerms = matchSearchTerms(title, searchTerms);
  const highlightSearch = useCallback(
    string => highlight(string, searchTerms),
    [searchTerms]
  );

  const filteredNodes = filterMatchingNodes(node.children, searchTerms);

  return (
    <li className="sitemap-list-item" key={node.id}>
      {matchesSearchTerms ? (
        <a className="d-inline-block" href={resourcePath}>
          {highlightSearch(title)}
        </a>
      ) : (
        <p>{title}</p>
      )}

      {filteredNodes.length > 0 && (
        <ul>
          {filteredNodes.map(childNode => {
            return <SitemapItem key={childNode.id} node={childNode} />;
          })}
        </ul>
      )}
    </li>
  );
};

export default SitemapItem;
